// @ts-ignore
import { sys, ref } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'

const { dark, light, typescale, fontWeight, fontFamily } = sys

export const getTooltipThemeByMode = (mode: Theme = 'light') => {
  const isLightMode = mode === 'light'
  const currentTheme = isLightMode ? light : dark

  return {
    background: currentTheme.elevation[200].background,
    boxShadow: light.elevation[200].boxShadow,
    color: currentTheme.text.primary,
    divider: currentTheme.common.divider[100],
    borderRadius: '2px',

    fontFamily: fontFamily.plain,
    fontSize: typescale[14].size,
    fontWeight: fontWeight.regular,
    lineHeight: typescale[14].lineHeight,
    padding: '8px 12px'
  }
}

export const getDataLabelColorByMode = (mode: Theme = 'light') => {
  const currentTheme = mode === 'light' ? light : dark
  return currentTheme.text.placeholder
}

export const getRedLabelColorByMode = (mode: Theme = 'light') => {
  const isLightMode = mode === 'light'
  return ref.color.red[isLightMode ? 900 : 400]
}
